import {
    FETCH_HEALTH_CHECKS,
    SET_CARD_SCORES,
    SET_NODE_SCORE,
    SET_SUBSCRIPTION
} from '../actions/actionTypes';

const initialState = {
    healthChecks:         [],
    healthChecksMeta:     {},
    order:                'asc',
    orderBy:              'name',
    cardScores:           {},
    nodeScore:            [],
    selectedSubscription: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_HEALTH_CHECKS:
            return {
                ...state,
                healthChecks:     [...action.payload.data],
                healthChecksMeta: { ...action.payload.meta }
            };
        case SET_CARD_SCORES:
            return {
                ...state,
                cardScores: {...action.payload}
            };
        case SET_NODE_SCORE:
            return {
                ...state,
                nodeScore: action.payload
            };
        case SET_SUBSCRIPTION:
            return {
                ...state,
                selectedSubscription: {...action.payload}
            };
        default:
            return state;
    }
};
